import { render, staticRenderFns } from "./screen-templates.vue?vue&type=template&id=7dd8a35a"
import script from "./screen-templates.vue?vue&type=script&lang=js"
export * from "./screen-templates.vue?vue&type=script&lang=js"
import style0 from "./screen-templates.vue?vue&type=style&index=0&id=7dd8a35a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports